export default __webpack_public_path__ + "static/media/twitter.c98a008a.svg";